import { render } from "./CostCenterManage.vue?vue&type=template&id=20007671"
import script from "./CostCenterManage.vue?vue&type=script&lang=js"
export * from "./CostCenterManage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__